function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "List View");

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle",
  x: 3,
  y: 2.5,
  width: 34,
  height: 6
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-9",
  x: 3,
  y: 17,
  width: 18.8310547,
  height: 6
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-10",
  x: 3,
  y: 31.5,
  width: 25.8828125,
  height: 6
});

function SvgListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "36px",
    viewBox: "0 0 34 36"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "media/images/list-view-8e66844f.svg";
export { SvgListView as ReactComponent };